import { Box, Button, Typography } from '@mui/material';
import CardGrid from '../../../components/cards/layout/CardGrid';
import {
  requestTypesIcons,
  requestTypesStrings,
} from '../../../components/special/requestTypes';
import CardContainer from '../../../components/cards/layout/CardContainer';
import moment from 'moment';
import { renderHours } from '../../time-tracking/worktime';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../global/theme/tokens';
import { API_GET, API_PATCH, DBRequest, useConfig } from '../../../api/api';
import Feedback from '../../../components/special/Feedback';
import { useEffect, useState } from 'react';
import PictureNameCard from '../../../components/cards/PictureNameCards/PictureNameCard';
import DateLabel from '../../../components/label/DateLabel';
import { useTranslation } from 'react-i18next';
import { useTimeTracking } from '../../../components/time-tracking/AppTimeProvider';
import { FreeDay } from '../NewTimeCompensation';

const ExtendTimeCompensation = ({ request, onUpdate }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const { t } = useTranslation();

  const { values } = request;
  const { daysFree, timeCost } = values;

  const format = 'DD.MM.YYYY';

  const [showRequest, setShowRequest] = useState(null);

  useEffect(() => {
    DBRequest({
      config,
      path: `employeerequests/${request.id}`,
      method: API_GET,
      onResponse: setShowRequest,
    });
  }, [request, config]);

  const startDateTime = moment(values.startDate, 'YYYY-MM-DD');
  const endDateTime = moment(values.endDate, 'YYYY-MM-DD');

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });

  function countDaysWithTargetMinutes(days) {
    if (!days) return 0;
    return days.filter((day) => day.targetTimeSeconds > 0).length;
  }

  return (
    <>
      <CardGrid>
        <CardContainer span={4} className="">
          <Typography
            variant="h3"
            className="flex items-center justify-center p-2 gap-2"
          >
            {requestTypesIcons[request.type]}
            {`${t(requestTypesStrings[request.type])} - `}
            <DateLabel date={request.createdAt} />
          </Typography>
        </CardContainer>

        <PictureNameCard
          data={showRequest?.data.user}
          type="user"
          title={t('Requester')}
          pictureUrl={
            showRequest?.data.user.picture
              ? showRequest?.data.user.picture.temporaryUrl
              : ''
          }
          name={`${showRequest?.data.user.firstName} ${showRequest?.data.user.lastName}`}
          mail={showRequest?.data.user.email}
          phone={showRequest?.data.user.phone}
          position={showRequest?.data.user.position}
        />

        <CardContainer>
          <Typography variant="h5" sx={{ color: colors.grey[600] }}>
            {startDateTime.format(format)}
          </Typography>
          <Typography variant="h5" sx={{ color: colors.grey[600] }}>
            {t('to-range')}
          </Typography>
          <Typography variant="h5" sx={{ color: colors.grey[600] }}>
            {endDateTime.format(format)}
          </Typography>
        </CardContainer>

        <CardContainer>
          {timeCost && (
            <Box className="flex justify-center items-center">
              <Box
                className="p-2 rounded-lg"
                sx={{ backgroundColor: colors.glass }}
              >
                <Typography variant="h2">
                  {renderHours(timeCost, true)} h
                </Typography>
              </Box>
            </Box>
          )}
        </CardContainer>

        {Array.isArray(daysFree) && (
          <CardContainer
            sx={{ backdropFilter: 'none', padding: '0px' }}
            span={5}
            noBackground
            className=" backdrop-blur-none"
          >
            <Box className="flex flex-col gap-2 py-2 lg:h-full overflow-y-auto w-full">
              <Box
                sx={{ bgcolor: colors.card }}
                className="backdrop-blur-md px-2 py-2 rounded-lg sticky top-0 flex justify-around z-10"
              >
                <Box>
                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    className=" opacity-50"
                  >
                    {t('Total')}
                  </Typography>
                  <Typography className="monospace">{`${daysFree?.length} ${
                    daysFree?.length > 1 ? t('Days') : t('Day')
                  }`}</Typography>
                </Box>
                <Box>
                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    className=" opacity-50"
                  >
                    {t('Workdays')}
                  </Typography>
                  <Typography className="monospace">{`${countDaysWithTargetMinutes(
                    daysFree
                  )} ${
                    countDaysWithTargetMinutes(daysFree) > 1
                      ? t('Days')
                      : t('Day')
                  }`}</Typography>
                </Box>
              </Box>
              {daysFree?.map((day) => (
                <FreeDay day={day} />
              ))}
            </Box>
          </CardContainer>
        )}
      </CardGrid>

      <Feedback setState={setAlertState} state={alertState} />
    </>
  );
};

export default ExtendTimeCompensation;
